import React, { useState } from 'react';
import { useImpersonate } from '../../../hooks/useAdminAuth';

export default function SaleDebug() {
  const lastOrderId = window.localStorage.getItem('orderId');
  const [email, setEmail] = useState('');
  const impersonate = useImpersonate();

  const send = () => {
    impersonate.mutate({ email: email });
    setEmail('');
  }

  return <div className="columns">
    <div className="column">
      <div className="title is-4">Sale Debug Data</div>
      <div className="mb-3">Last Order ID: {lastOrderId}</div>
    </div>

    <div className="column">
      <div className="title is-4">Impersonate User</div>

      <div className="field">
        <label className="label">Email</label>
        <div className="control">
          <input
            type="text"
            className="input"
            name="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
      </div>

      <button className="button" onClick={send}>Submit</button>
    </div>
  </div>
}
